export const ACCOUNT_SECTION = {
  PREFERENCES: 'preferences',
  CANDIDATE_NOTIFICATIONS: 'notifications',
  RECRUITER_NOTIFICATIONS: 'recruiter-notifications',
  PRIVACY: 'privacy',
  SECURITY: 'security',
  SUBSCRIPTION: 'subscription',
  BILLING: 'billing',
};

export const ACCOUNT_SECTION_CONFIG = {
  [ACCOUNT_SECTION.PREFERENCES]:{
    caption: 'Account Preferences',
    icon: '',
    name: ACCOUNT_SECTION.PREFERENCES,
    visible: true,
  },
  [ACCOUNT_SECTION.SUBSCRIPTION]:{
    caption: 'GoBuyside Account',
    icon: '',
    name: ACCOUNT_SECTION.SUBSCRIPTION,
    visible: true,
  },
  [ACCOUNT_SECTION.CANDIDATE_NOTIFICATIONS]:{
    caption: 'Candidate Notifications',
    icon: '',
    name: ACCOUNT_SECTION.CANDIDATE_NOTIFICATIONS,
    visible: true,
  },
  [ACCOUNT_SECTION.RECRUITER_NOTIFICATIONS]:{
    caption: 'Recruiter Notifications',
    icon: '',
    name: ACCOUNT_SECTION.RECRUITER_NOTIFICATIONS,
    visible: true,
  },
  [ACCOUNT_SECTION.PRIVACY]:{
    caption: 'Visibility & Privacy',
    icon: '',
    name: ACCOUNT_SECTION.PRIVACY,
    visible: true,
  },
  [ACCOUNT_SECTION.BILLING]:{
    caption: 'Billing Information',
    icon: '',
    name: ACCOUNT_SECTION.BILLING,
    visible: true,
  },
  [ACCOUNT_SECTION.SECURITY]:{
    caption: 'Password & Security',
    icon: '',
    name: ACCOUNT_SECTION.SECURITY,
    visible: true,
  },
}

export const ACCOUNT_UNSUBSCRIBE_MODE = {
  HARD: 'Hard',
  SOFT: 'Soft',
  OFF_MARKET: 'OffMarket',
  NO: 'No',
}
